export enum EntryPoint {
    LOGIN = 'login',
    REFRESH = 'refresh',
    USERS = 'users',
    GROUPS = 'groups',
    GROUP_USERS = 'group-users',
    PROJECTS_LIST = 'projectsList',
    PROJECTS = 'projects',
    PROJECTS_FILES = 'projectsFiles',
    LAYERS_LIST = 'layersList',
    LAYERS = 'layers',
    JOB_SITES = 'sites',
    JOB_SITES_FILES = 'sitesFiles',
    LAYERS_FILES = 'layersFiles',
    LAYER_CONFIGURATIONS = 'layerConfigurations',
    PROJECT_CONFIGURATIONS = 'projectConfigurations',
    JOB_SITE_CONFIGURATIONS = 'siteConfigurations',
    CATEGORIES = 'categories',
    PROCESSES = 'processes',
    JOBS = 'jobs',
    SINGLE_PART_UPLOAD = 'singlePartUpload',
    ANONYMOUS_CODE = 'anonymous-code',
    PREFERENCES = 'preferences',
    EVENTS = 'events',
    CLOUD_ID = 'cloudId',
    MULTIPART_UPLOAD = 'multiPartUpload',
    REPORT = 'reports',
    SUPPORT = 'support',
    PERMISSIONS = 'permissions',
    GET_TOKEN = 'get-token',
    LATEST_DASHBOARD_ELEMENTS = 'latestDashboardElements',
    ACL_GROUPS = 'aclGroups',
    ACL_USERS = 'aclUsers',
}
